<template>
  <div class="uploader">
    <van-image
      v-if="fileList.length"
      :src="fileList && fileList.length ? fileList[0].url : ''"
      width="32"
      height="32"
      @click="previewImage"
    />
    <van-icon
      v-else
      name="photograph"
      color="#ddd"
      size="18"
      @click="chooseImage"
    />
    <div class="clear" v-if="fileList.length" @click="clearImage">
      <van-icon name="cross" color="#fff" size="6" />
    </div>
    <van-image-preview
      v-if="false"
      v-model:show="show"
      :images="images"
    ></van-image-preview>
  </div>
</template>

<script>
import { ImagePreview } from "vant"
import { ref, toRefs } from "vue"
export default {
  props: {
    schoolCode: {
      type: String,
      default: "",
    },
    moduleName: {
      type: String,
      default: "visitor",
    },
    defaultFileList: {
      type: Array,
      default() {
        return []
      },
    },
  },
  setup(props, { emit }) {
    let { schoolCode, moduleName, defaultFileList } = toRefs(props)
    const fileList = ref([...defaultFileList.value])
    /* eslint-disable */
    dd.onMessage = (resouceData) => {
      console.log(resouceData)
      let { status, type, data } = resouceData
      if (type == "chooseImage") {
        if (status == 200) {
          if (data.fileList && data.fileList.length) {
            fileList.value = data.fileList
          }
          emit("upload", data)
        }
      }
    }
    /* eslint-disable */

    const chooseImage = () => {
      /* eslint-disable */
      dd.postMessage({
        type: "chooseImage",
        params: {
          schoolCode: schoolCode.value,
          moduleName: moduleName.value,
        },
      })
      /* eslint-disable */
    }

    const previewImage = () => {
      ImagePreview([fileList.value[0].url])
    }

    const clearImage = () => {
      fileList.value = []
      emit("clear")
    }

    return {
      fileList,
      chooseImage,
      previewImage,
      clearImage,
    }
  },
}
</script>

<style lang="less" scoped>
.uploader {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background-color: rgba(200, 200, 200, 0.1);
  margin-right: 6px;
  cursor: pointer;
  overflow: hidden;
  .clear {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 12px;
    height: 12px;
    background-color: rgba(0, 0, 0, 0.9);
    border-radius: 0 0 0 60%;
  }
}
</style>
